import o from 'react';
import { useBaseModalContext, BackIcon, CloseIcon } from '@crossbell/ui';
import h from 'classnames';

var f="a61ed9af2f2ec5f836bf3fbf766f18c1c1eae6abf53f75e07c377c003de9a708",v=`._uxOverlay_1h6jw_1 {
	position: relative;
	cursor: pointer;
}

._uxOverlay_1h6jw_1::after {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: inherit;
	background: rgb(var(--csb-ck-color-text));
	opacity: 0;
	transition: opacity 0.2s;
	pointer-events: none;
}

._uxOverlay_1h6jw_1:hover::after {
	opacity: 0.05;
}

._uxOverlay_1h6jw_1:active::after {
	opacity: 0.15;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(f)){var e=document.createElement("style");e.id=f,e.textContent=v,document.head.appendChild(e);}})();var u={uxOverlay:"_uxOverlay_1h6jw_1"};var p="88425e6d8f047d5c94d185d81935da0243e194fee523059bc5119a2e6aa3f125",x=`._btn_34ita_1 {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	border: none;
	background: transparent;
	outline: none;
	border-radius: 8px;
	color: rgb(var(--csb-ck-color-text-subtle));
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(p)){var e=document.createElement("style");e.id=p,e.textContent=x,document.head.appendChild(e);}})();var m={btn:"_btn_34ita_1"};function s(e){return o.createElement("button",{...e,className:h(m.btn,e.className,u.uxOverlay)})}var b="4d25829d2ca75e29d494a91ef2f87dfbefc9582e4d7ccda5acce1fc6a2a5dbb9",S=`._container_10bfu_1 {
	padding: 23px 21px 10px;
}

._container_10bfu_1 button:focus {
	outline: none;
}

._main_10bfu_9 {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	grid-gap: 0.25rem;
	gap: 0.25rem;
}

._title_10bfu_18 {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	white-space: nowrap;
	font-size: 16px;
	font-weight: 500;
	color: rgb(var(--csb-ck-color-text));
}

._backIcon_10bfu_29 {
	transform: translateX(25%);
}

._hidden_10bfu_33 {
	pointer-events: none;
	opacity: 0;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(b)){var e=document.createElement("style");e.id=b,e.textContent=S,document.head.appendChild(e);}})();var i={container:"_container_10bfu_1",main:"_main_10bfu_9",title:"_title_10bfu_18",backIcon:"_backIcon_10bfu_29",hidden:"_hidden_10bfu_33"};function F({title:e,leftNode:n,rightNode:t,onGoBack:r,isAbleToGoBack:c,onClose:a,isAbleToClose:_=!0}){let d=useBaseModalContext(),l=d.canClose&&_;return o.createElement("div",{"data-animation":"fade-in",className:i.container},o.createElement("div",{className:i.main},o.createElement("div",null,n??(c&&r&&o.createElement(s,{onClick:r},o.createElement(BackIcon,{className:i.backIcon})))),o.createElement("div",{className:i.title},e),o.createElement("div",null,t??(a&&o.createElement(s,{disabled:!l,className:h(!l&&i.hidden),onClick:a??d.onClose},o.createElement(CloseIcon,null))))))}var G=(e,n)=>({isActive:!1,hide:()=>{let{isActive:t}=n();t&&e({isActive:!1});},show:()=>{let{isActive:t}=n();t||e({isActive:!0});}});function X(e,n=t=>!t.isActive){return new Promise(t=>{if(n(e.getState()))return;let c=e.subscribe(a=>{n(a)&&(t(),c());});})}

export { G as a, X as b, s as c, F as d };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XCSSTYD2.mjs.map